import axios from 'axios'
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

export let reservationModeObjects = {
    "reservation_mode": "day",
    "select_service_before_time": 0,
    "select_service_before_time_type": "day",
    "base": {
        "price": 95000,
        "offer": 5000,
        "min_reservation": 1,
        "max_reservation": "infinity",
        "reset_time": 1,
        "time_between_each_reservation": 40
    },
    "check_in_check_out": [
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        },
        {
            "check_in": {
                "min": "16:00",
                "max": "16:00"
            },
            "check_out": {
                "max": "14:00"
            }
        }
    ],
    "off_times": {},
    "custom_price": {},
    "custom_min_max_reservation": {},
    "extra_items": {},
    "work_times": [],
}

export let originalExtraOptionShape = {
    item: {
        id: 1,
        name: "1 نفر",
        value: 1,
        price: 0,
        offer: 0,
        show: true
    },
    properties: {
        select_status: "required",
        title: "نام دلخواه",
        type: "selectbox",
        status: true
    }
}

export const createNestedObject = (base, names, value) => {
    var item = arguments.length === 3 ? names.pop() : false;

    for (var i = 0; i < names.length; i++) {
        base = base[names[i]] = base[names[i]] || {};
    }

    if (item) base = base[item] = value;

    return base;
};

export const addMonths = (date, months) => {
    let day = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() != day) {
        date.setDate(0);
    }
    return date;
}

// date should be new Date object and next month will be generate from that point
export const getNextMonths = (date = new Date(), months = 3) => {
    let result = []
    // add current date to capture his month
    result.push(date)

    // add next two date in next months
    for (let i = 1; i <= (months - 1); i++) {
        let nextMonth = addMonths(new Date(), i);
        result.push(nextMonth)
    }
    return result
}

export const findFirstAndLastDayOfMonth = (date) => {
    date = new Date(date)
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    let monthDays = new Date(year, month, 0).getDate()
    let firstDate = new Date(`${year} ${month} 1`)
    let LastDate = new Date(`${year} ${month} ${monthDays}`)

    return {
        firstDay: firstDate,
        lastDay: LastDate,
    }
}


export default {
    namespaced: true,
    state: {
        reservationRule: {},
        reservationTimes: [],
        month: parseInt(new Date().toLocaleDateString('fa-IR-u-nu-latn', {month: '2-digit'})),
        year: parseInt(new Date().toLocaleDateString('fa-IR-u-nu-latn', {year: 'numeric'})),
        ...filtersCopy,
    },
    mutations: {
        setReservationRule(state, reservationRule) {
            state.reservationRule = reservationRule
        },
        setReservationTimes(state, reservationTimes) {
            state.reservationTimes = reservationTimes
        },
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
        setYear(state, year) {
            state.year = year
        },
        setMonth(state, month) {
            state.month = month
        }
    },
    actions: {
        async getDashboardProductRules({commit, state}, form) {

            const request = await axios.post(`/reservation-rules/product/${form.product}`, form);

            let data = request.data.data;
            if (data.length === 0) {
                return request
            }

            if (!form.withoutState) {
                commit('setReservationRule', data.reservation_rule)
            }

            return request
        },
        async updateReservationRule({commit, state}, form) {

            const request = await axios.put(`/reservation-rules/product/${form.product}`, form);
            let data = request.data.data;

            return request
        },
        async getProductAvailableTimes({commit, state}, form) {
            const request = await axios.post(`/reservation-take-time/product/${form.product_id}`, form);

            let data = request.data.data;
            if (data.length === 0) {
                return request
            }

            if (!form.withoutState) {
                commit('setReservationTimes', data.available_times)
            }

            return request
        }
    },
    getters: {
        getReservationRule: state => state.reservationRule,
        getReservationTimes: state => state.reservationTimes,
        getFilters: (state) => state.filters,
        getYear: (state) => state.year,
        getMonth: (state) => state.month,
    }
}